<template>
    <div>
        <el-upload
            ref="uploadRef"
            v-if="permissionsShow"
            :action="action"
            :multiple="multiple"
            :on-remove="onRemove"
            :show-file-list="showFileList"
            :limit="limit"
            :drag="drag"
            :list-type="listType"
            :disabled="disabled"
            :accept="accept"
            :auto-upload="autoUpload"
            :on-preview="onPreview"
            :on-exceed="_handleExceed"
            :on-success="onSuccess"
            :on-error="onError"
            :on-progress="onProgress"
            :before-remove="_beforeRemove"
            :on-change="_handChange"
            :before-upload="_beforeUpload"
            :file-list="fileList"
            :data="data"
            :name="name"
            :with-credentials="withCredentials"
            :http-request="httpRequest"
            :headers="headers"
        >
            <i class="el-icon-upload" v-if="drag"></i>
            <div class="el-upload__text" v-if="drag">
                {{ $t('component.DRAP_FILE') }}<em>{{ $t('component.CLICK_UPLOAD') }}</em>
            </div>
            <i class="el-icon-plus" v-if="listType == 'picture-card'"></i>
            <td-button
                slot="trigger"
                :size="selectFileBtnSize"
                :loading="selectFileLoading"
                style="margin-right:5px"
                :type="selectFileBtnType"
                v-if="!autoUpload && !drag && listType !== 'picture-card'"
                >{{ $t(selectBtnlabel) }}</td-button
            >
            <td-button :loading="uploadFileLoading" type="success" @click="submitUpload" :size="uploadFileBtnSize" v-if="!autoUpload && !drag && listType !== 'picture-card' && hasManual">{{
                $t(uploadFileBtnlabel)
            }}</td-button>
            <td-button :loading="uploadFileLoading" :type="uploadFileBtnType" :size="uploadFileBtnSize" v-if="autoUpload == true && drag == false">{{ $t(uploadFileBtnlabel) }}</td-button>
            <div class="el-upload__tip" slot="tip" v-if="messageShow">{{ $t(message) }}</div>

            <div v-if="imageButtonShow" slot="file" slot-scope="{ file }">
                <div class="el-upload-list__item is-ready">
                    <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
                </div>
                <span class="el-upload-list__item-actions">
                    <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                        <i class="el-icon-zoom-in"></i>
                    </span>
                    <span v-if="isShowRemove" class="el-upload-list__item-delete" @click="handleRemove(file)">
                        <i class="el-icon-delete"></i>
                    </span>
                </span>
            </div>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible" :width="width" title="预览" append-to-body="true">
            <img style="width:100%" :src="dialogImageUrl" @load="onLoad" />
        </el-dialog>
    </div>
</template>
<script>
export default {
    props: {
        /* 必选参数，上传的地址 */
        actionUrl: {
            type: String,
            default: function() {
                return '';
            }
        },
        /*  是否支持多选文件 */
        multiple: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        /* 最大允许上传个数 */
        limit: {
            type: Number
        },
        /* 是否显示已上传文件列表 */
        showFileList: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        /* 是否启用拖拽上传 */
        drag: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        /* 接受上传的文件类型（thumbnail-mode 模式下此参数无效） */
        accept: {
            type: String,
            default: function() {
                return '';
            }
        },
        /* 文件列表的类型    text/picture/picture-card */
        listType: {
            type: String,
            default: function() {
                return 'text';
            }
        },
        /* 是否禁用 */
        disabled: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 是否显示删除
        isShowRemove: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        /* 是否在选取文件后立即进行上传 */
        autoUpload: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        /* 限制大小 单位MB */
        limitSize: {
            type: Number,
            default: function() {
                return 500;
            }
        },
        message: {
            type: String,
            default: function() {
                return 'component.UPLOAD_MESSAGE';
            }
        },
        /* 是否手动上传 */
        hasManual: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        /* 上传时附带的额外参数 */
        data: Object,
        /* 上传的文件字段名 */
        name: {
            type: String,
            default: 'file'
        },
        /* 支持发送 cookie 凭证信息 */
        withCredentials: Boolean,
        /* 覆盖默认的上传行为，可以自定义上传的实现 */
        httpRequest: {
            type: Function
        },
        selectFileBtnType: {
            type: String,
            default: 'primary'
        },
        selectBtnlabel: {
            type: String,
            default: 'component.SELECT_FILE'
        },
        uploadFileBtnType: {
            type: String,
            default: 'primary'
        },
        uploadFileBtnlabel: {
            type: String,
            default: 'component.UPLOAD_FILE'
        },
        /* 点击文件列表中已上传的文件时的钩子 */
        onPreview: Function,
        /* 文件上传成功时的钩子 */
        onSuccess: Function,
        /*  文件上传失败时的钩子*/
        onError: Function,
        /*  文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用*/
        onChange: Function,
        onRemove: Function,
        beforeUpload: Function,
        beforeRemove: Function,
        onExceed: Function,
        /* 选择文件按钮的大小 */
        selectFileBtnSize: {
            type: String,
            default: 'medium'
        },
        /* 上传文件按钮大小 */
        uploadFileBtnSize: {
            type: String,
            default: 'medium'
        },
        /* 选择文件按钮loading */
        selectFileLoading: {
            type: Boolean,
            default: false
        },
        /* 上传按钮loading */
        uploadFileLoading: {
            type: Boolean,
            default: false
        },
        /* 所有权限信息 */
        permissions: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 角色信息 */
        roles: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 权限之一 */
        oneOfPermissions: {
            type: Array,
            default: function() {
                return [];
            }
        },
        imageButtonShow: {
            type: Boolean,
            default: function() {
                return false;
            }
        }
    },
    data() {
        return {
            /* 是否满足显示权限 */
            permissionsShow: true,
            /* 上传的文件列表, 例如: [{name: 'food.jpg', url: 'https://xxx.cdn.com/xxx.jpg'}] */
            fileList: [],
            dialogImageUrl: '',
            width: '50%',
            dialogVisible: false,
            /* 类型是否错误 */
            fileTypeError: false,
            /* 大小是否超出限制 */
            isLimitError: false,
            action: '',
            messageShow: true, //提示信息是否显示
            /* 上传头部参数 */
            headers: {
                token: sessionStorage.getItem('token')
            }
        };
    },
    created() {
        /* 权限数据处理 */
        if (this.permissions.length > 0 || this.oneOfPermissions.length > 0 || this.roles.length > 0) {
            this.permissionsShow = this.dealPermissions(this.permissions, this.roles, this.oneOfPermissions);
        }
        this.action = window.config.host + this.actionUrl;
        if (this.message === '') {
            this.messageShow = false;
        }
    },
    /* 具体方法实现 */
    methods: {
        /* 手动上传 */
        submitUpload() {
            if (this.fileList.length === 0) {
                this.$message({ showClose: true, message: this.$t('common.PLEASESELECTFILE'), type: 'warning' });
                return;
            }
            this.$refs.uploadRef.submit();
        },
        /* 清空已上传的文件列表（该方法不支持在 before-upload 中调用） */
        clearFiles() {
            this.$refs.uploadRef.clearFiles();
        },
        /* 取消上传请求 */
        abort() {
            this.$refs.uploadRef.abort();
        },
        /* 手动上传文件列表 */
        submit() {
            this.$refs.uploadRef.submit();
        },
        /* 文件超出限制的钩子 */
        _handleExceed(files, fileList) {
            if (this.onExceed !== undefined) {
                this.onExceed(files, fileList);
            } else {
                this.$message({ showClose: true, message: this.$t('common.FILE_NUMBER_OVERTOP'), type: 'warning' });
            }
        },
        /* 上传前的验证 */
        _beforeUpload(file) {
            this.fileTypeError = false;
            this.isLimitError = false;
            if (this.beforeUpload != undefined) {
                return this.beforeUpload(file);
            } else {
                let fileExtend = file.name.substring(file.name.lastIndexOf('.') + 1);
                if (this.accept !== '' && this.accept.toLowerCase().indexOf(fileExtend.toLowerCase()) <= -1) {
                    this.fileTypeError = true;
                    this.$message({
                        showClose: true,
                        message: this.$t('error.ERROR_UPLOAD_FILE_TYPE') + ' , ' + this.$t('component.PLEASE_SELECT') + this.accept + this.$t('component.FILE_TYPE'),
                        type: 'warning'
                    });
                    return false;
                }
                const isLimit = file.size / 1024 / 1024 < this.limitSize;
                if (!isLimit) {
                    this.isLimitError = true;
                    this.$message({ showClose: true, message: this.$t('error.ERROR_UPLOAD_FILE_SIZE'), type: 'warning' });
                    return false;
                }
                return true;
            }
        },
        /* 移除文件前进行调用 */
        _beforeRemove(file, fileList) {
            if (this.beforeRemove != undefined) {
                return this.beforeRemove(file);
            } else {
                if (!this.fileTypeError && !this.isLimitError) {
                    return this.$confirm(`${this.$t('common.CONFIRM_ROMVE')} ${file.name}？`);
                }
                this.fileTypeError = false;
                this.isLimitError = false;
            }
        },
        /* 文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用 */
        _handChange(file, fileList) {
            /* 单选时移除原有列表数据 */
            if (!eval(this.multiple) && fileList.length > 1) {
                fileList.shift();
            }
            this.fileList = fileList;
            if (this.onChange != undefined) {
                this.onChange(file, fileList);
            }
        },
        onLoad(e) {
            var img = new Image();
            img.src = this.dialogImageUrl;
            let width = 0;
            if (img.width < 100) {
                width = '120';
            } else if (img.width > 100 && img.width < 600) {
                width = img.width + 40;
            } else {
                width = 600;
            }
            this.width = width + 'px';
        },
        handleRemove(file) {
            for (var i in this.fileList) {
                if (file == this.fileList[i]) {
                    this.fileList.splice(i, 1);
                }
            }
            this.$emit('handleRemove', file, this.fileList);
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        }
    }
};
</script>
<style>
.el-upload--picture-card {
    width: 233px !important;
    height: 163px !important;
}
.el-upload-dragger {
    width: 233px !important;
    height: 163px !important;
}
</style>
